import { VEHICLE_TYPES } from '../../../common/constants';

export default VEHICLE_TYPES;
